import { closePopupHelper, openPopupHelper } from 'reactApp/modules/popup/popup.helpers';
import { popupNames } from 'reactApp/modules/popup/popup.types';

import type { PaidUserReturnModalProps } from './PaidUserReturnModal';

export const renderPaidUserReturnModal = ({ onClose, ...data }: PaidUserReturnModalProps) =>
    openPopupHelper({ popupName: popupNames.PAID_USER_RETURN_MODAL, data, onClose });

export const closePaidUserReturnModal = () => closePopupHelper(popupNames.PAID_USER_RETURN_MODAL);
